function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from '../../util';
import { useTranslation } from 'react-i18next';
import generalRouteService from '../../services/general_route.service';
import { useErrorHandling } from '../../hooks/useErrorHandling';
import fileUploadService from '../../util/files/file_upload.service';
import { uploadAllSelectedFiles } from '../../util/files/uppyGcpCustomImplementation';
import FolderBody from '@rd-web-markets/market/dist/folder_and_files/FolderBody';
import FileBody from '@rd-web-markets/market/dist/folder_and_files/FileBody';
import createFolderValidation from './create_folder_validation';
import { Col, Row, Form } from 'react-bootstrap';
const CreateFolderOrFileModal = _ref => {
  var _userClaimGroupAbilit;
  let {
    route,
    show,
    onHide,
    allData,
    setAllData,
    currentFolderId,
    targetModelId,
    type,
    userClaimGroupAbilities
  } = _ref;
  const {
    t
  } = useTranslation();
  const [body, setBody] = useState({});
  const [uploadAllowed, setUploadAllowed] = useState(false);
  const [fileNotSelected, setFileNotSelected] = useState(false);
  const [uppyInstance, setUppyInstance] = useState(null);
  const [userIsEditingFile, setUserIsEditingFile] = useState(false);
  const [isSelectingMoreFilesDisabled, setIsSelectingMoreFilesDisabled] = useState(false);
  const onUserEditFileStart = useCallback(() => setUserIsEditingFile(true), []);
  const onUserEditFileEnd = useCallback(() => setUserIsEditingFile(false), []);
  const getPresignedUrl = fileUploadService.useGetPresignedUrl();
  const createFolderFile = fileUploadService.useCreateFolderFile({
    onSuccess: () => console.log('File record created successfully.'),
    onError: error => console.error('File record creation failed:', error)
  });
  const documentTypeAbilities = userClaimGroupAbilities === null || userClaimGroupAbilities === void 0 || (_userClaimGroupAbilit = userClaimGroupAbilities.pages) === null || _userClaimGroupAbilit === void 0 ? void 0 : _userClaimGroupAbilit.any;
  const hasDocumentTypeAbilities = !!documentTypeAbilities;
  const canAccessFinancialDocuments = documentTypeAbilities === null || documentTypeAbilities === void 0 ? void 0 : documentTypeAbilities.canAccessFinancialDocuments;
  const canAccessTechnicalDocuments = documentTypeAbilities === null || documentTypeAbilities === void 0 ? void 0 : documentTypeAbilities.canAccessTechnicalDocuments;
  const getInitialBody = useCallback(() => {
    if (!hasDocumentTypeAbilities) return {};
    if (canAccessFinancialDocuments && !canAccessTechnicalDocuments) return {
      is_financial: true,
      is_technical: false
    };
    if (!canAccessFinancialDocuments && canAccessTechnicalDocuments) return {
      is_financial: false,
      is_technical: true
    };
    return {};
  }, [hasDocumentTypeAbilities, canAccessFinancialDocuments, canAccessTechnicalDocuments]);
  useEffect(() => {
    setBody(getInitialBody());
    if (!show) {
      setUploadAllowed(false);
      setIsSelectingMoreFilesDisabled(false);
      setFileNotSelected(false);
    }
  }, [show, getInitialBody]);
  const createFolder = useErrorHandling(useCallback(async () => {
    const payload = {
      name: body.name,
      notes: body.notes || null,
      parent_folder_id: currentFolderId,
      folderable_id: targetModelId,
      folderable_type: type,
      is_financial: body.is_financial || false,
      is_technical: body.is_technical || false,
      is_internal_only: body.is_internal_only || false
    };
    const response = await generalRouteService.create(route, payload);
    setAllData([...allData, response]);
  }, [body, currentFolderId, targetModelId, type, route, setAllData, allData]));
  const onSelectFile = useCallback(file => {
    setBody(prev => {
      if (file !== null && file !== void 0 && file.name && !prev.name) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          name: file.name.replace(/\.pdf$/, '')
        });
      }
      return prev;
    });
    setFileNotSelected(!(file !== null && file !== void 0 && file.name));
  }, []);
  const createFolderFileWithCloudFileRecord = useErrorHandling(useCallback(async (cloudFileRecord, uppyFileRecord) => {
    const payload = {
      name: uppyFileRecord.meta.name,
      notes: body.notes || null,
      folder_id: currentFolderId,
      fileable_id: targetModelId,
      fileable_type: type,
      is_financial: body.is_financial || false,
      is_technical: body.is_technical || false,
      is_internal_only: body.is_internal_only || false
    };
    const response = await createFolderFile(payload, cloudFileRecord);
    if (response) {
      setAllData(prevData => [...prevData, response]);
    }
  }, [currentFolderId, targetModelId, type, createFolderFile, setAllData, body]));
  const uploadFiles = useCallback(async () => {
    setIsSelectingMoreFilesDisabled(true);
    await uploadAllSelectedFiles(uppyInstance, getPresignedUrl, createFolderFileWithCloudFileRecord);
    setIsSelectingMoreFilesDisabled(false);
  }, [createFolderFileWithCloudFileRecord, getPresignedUrl, uppyInstance]);
  const renderBody = /*#__PURE__*/React.createElement(React.Fragment, null, route === 'folders' ? /*#__PURE__*/React.createElement(FolderBody, {
    body: body,
    setBody: setBody,
    userClaimGroupAbilities: userClaimGroupAbilities
  }) : /*#__PURE__*/React.createElement(FileBody, {
    onSelectFile: onSelectFile,
    setUppyInstance: setUppyInstance,
    onUserEditFileStart: onUserEditFileStart,
    onUserEditFileEnd: onUserEditFileEnd,
    isAddingFilesDisabled: isSelectingMoreFilesDisabled,
    setBody: setBody,
    body: body,
    userClaimGroupAbilities: userClaimGroupAbilities
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2 mt-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('notes')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    name: "notes",
    value: body.notes || '',
    size: "md",
    onChange: e => setBody(prev => _objectSpread(_objectSpread({}, prev), {}, {
      notes: e.target.value
    }))
  }))));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: route === 'folders' ? t('new_folder') : t('upload_file'),
    show: show,
    renderBody: () => renderBody,
    onHide: onHide,
    onSubmit: () => route === 'folders' ? createFolder() : uploadFiles(),
    submitText: route === 'folders' ? t('create') : t('upload'),
    disabled: route === 'folders' ? createFolderValidation(body) : fileNotSelected || userIsEditingFile || createFolderValidation(body)
  });
};
export default CreateFolderOrFileModal;